import React from "react";
import Element from '../element';
import './header.scss';

export default class Header extends React.Component {
    static defaultProps = {
        icon: null,
        title: null,
        description: null,
    }
    render() {
        const { icon, title, description } = this.props;

        const iconDOM = icon ? <Element className='icon' data={icon} /> : null;

        return (
            <div className='header'>
                <div className='container'>
                    {iconDOM}
                    <Element className='title' data={title} />
                    <Element className='description' data={description} />
                </div>
            </div>
        );
    }
}